module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v3/7foreword#foreword"
    }
  }, [_vm._v("Foreword: “Edward Whittemore (1933–1995)” by Tom Wallace")])]), _vm._v(" "), _c('h3', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/1cover"
    }
  }, [_vm._v("Sinai Tapestry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v1/10chap2#chap2"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/11chap3#chap3"
    }
  }, [_vm._v("1. Strongbow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/12chap4#chap4"
    }
  }, [_vm._v("2. Wallenstein")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/13chap5#chap5"
    }
  }, [_vm._v("3. Cairo 1840")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/14chap6#chap6"
    }
  }, [_vm._v("4. Sinai 1836–1843")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/15chap7#chap7"
    }
  }, [_vm._v("5. The Haj")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/16chap8#chap8"
    }
  }, [_vm._v("6. YHWH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/17chap9#chap9"
    }
  }, [_vm._v("7. The Tiberias Telegrams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v1/18chap10#chap10"
    }
  }, [_vm._v("Part Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/19chap11#chap11"
    }
  }, [_vm._v("8. O’Sullivan Beare")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/20chap12#chap12"
    }
  }, [_vm._v("9. Haj Harun")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/21chap13#chap13"
    }
  }, [_vm._v("10. The Scarab")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/22chap14#chap14"
    }
  }, [_vm._v("11. Maud")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/23chap15#chap15"
    }
  }, [_vm._v("12. Aqaba")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/24chap16#chap16"
    }
  }, [_vm._v("13. Jericho")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v1/25chap17#chap17"
    }
  }, [_vm._v("Part Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/26chap18#chap18"
    }
  }, [_vm._v("14. Stern")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/27chap19#chap19"
    }
  }, [_vm._v("15. The Jordan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/28chap20#chap20"
    }
  }, [_vm._v("16. Jerusalem 700 B.C.–1932")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/29chap21#chap21"
    }
  }, [_vm._v("17. The Bosporua")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/30chap22#chap22"
    }
  }, [_vm._v("18. Melchizedek 220 B.C.–1933")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/31chap23#chap23"
    }
  }, [_vm._v("19. Athens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/32chap24#chap24"
    }
  }, [_vm._v("20. Smyrna 1922")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/33chap25#chap25"
    }
  }, [_vm._v("21. Cairo 1942")])]), _vm._v(" "), _c('h3', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/1cover"
    }
  }, [_vm._v("Jerusalem Poker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/8chap1#chap1"
    }
  }, [_vm._v("Introduction by Lesley Hazleton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/v3/prologue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v3/9chap2#chap2"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/10chap3#chap3"
    }
  }, [_vm._v("1. Jerusalem 1933")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/11chap4#chap4"
    }
  }, [_vm._v("2. Cairo Martyr")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/12chap5#chap5"
    }
  }, [_vm._v("3. Cheops’ Pyramid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/13chap6#chap6"
    }
  }, [_vm._v("4. Solomon’s Quarries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v3/14chap7#chap7"
    }
  }, [_vm._v("Part Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/15chap8#chap8"
    }
  }, [_vm._v("5. Munk Szondi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/16chap9#chap9"
    }
  }, [_vm._v("6. St. Catherine’s Monastery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/17chap10#chap10"
    }
  }, [_vm._v("7. Haj Harun")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/18chap11#chap11"
    }
  }, [_vm._v("8. Joker Wild")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v3/19chap12#chap12"
    }
  }, [_vm._v("Part Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/20chap13#chap13"
    }
  }, [_vm._v("9. Nubar Wallenstein")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/21chap14#chap14"
    }
  }, [_vm._v("10. Sophia the Black Hand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/22chap15#chap15"
    }
  }, [_vm._v("11. Gronk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v3/23chap16#chap16"
    }
  }, [_vm._v("Part Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/24chap17#chap17"
    }
  }, [_vm._v("12. Maud")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/25chap18#chap18"
    }
  }, [_vm._v("13. O’Sullivan Beare")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/26chap19#chap19"
    }
  }, [_vm._v("14. Stern")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/27chap20#chap20"
    }
  }, [_vm._v("15. Sheik Ibrahim ibn Harun")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/28chap21#chap21"
    }
  }, [_vm._v("16. Venice 1933")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/29chap22#chap22"
    }
  }, [_vm._v("17. Crypt, Cobbler")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v3/30chap23#chap23"
    }
  }, [_vm._v("18. Bernini")])]), _vm._v(" "), _c('h3', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/1cover"
    }
  }, [_vm._v("Nile Shadows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/8chap1#chap1"
    }
  }, [_vm._v("“Nile Shadows: The Improbable Art of Edward Whittemore” by Ben Gibberd")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v2/9chap2#chap2"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/10chap3#chap3"
    }
  }, [_vm._v("1. An Australian Hand Grenade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/11chap4#chap4"
    }
  }, [_vm._v("2. The Purple Seven Armenian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/12chap5#chap5"
    }
  }, [_vm._v("3. Hopi Mesa Kiva")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v2/13chap6#chap6"
    }
  }, [_vm._v("Part Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/14chap7#chap7"
    }
  }, [_vm._v("4. Vivian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/15chap8#chap8"
    }
  }, [_vm._v("5. Liffy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/16chap9#chap9"
    }
  }, [_vm._v("6. Sphinx")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/17chap10#chap10"
    }
  }, [_vm._v("7. Monastery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/18chap11#chap11"
    }
  }, [_vm._v("8. Maud")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/19chap12#chap12"
    }
  }, [_vm._v("9. Menelik")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/20chap13#chap13"
    }
  }, [_vm._v("10. Ahmad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/21chap14#chap14"
    }
  }, [_vm._v("11. Trombone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/22chap15#chap15"
    }
  }, [_vm._v("12. Beggar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v2/23chap16#chap16"
    }
  }, [_vm._v("Part Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/24chap17#chap17"
    }
  }, [_vm._v("13. Cohen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/25chap18#chap18"
    }
  }, [_vm._v("14. Bletchley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/26chap19#chap19"
    }
  }, [_vm._v("15. The Sisters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/27chap20#chap20"
    }
  }, [_vm._v("16. Two Candles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/28chap21#chap21"
    }
  }, [_vm._v("17. Mementos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/29chap22#chap22"
    }
  }, [_vm._v("18. Crypt/Mirror")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v2/30chap23#chap23"
    }
  }, [_vm._v("Part Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/31chap24#chap24"
    }
  }, [_vm._v("19. A Golden Bell and a Pomegranate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/32chap25#chap25"
    }
  }, [_vm._v("20. A Gift of Faces, a Gift of Tongues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/33chap26#chap26"
    }
  }, [_vm._v("21. Purple Seven Moonlight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/34chap27#chap27"
    }
  }, [_vm._v("22. Bernini’s Bag")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v2/35chap28#chap28"
    }
  }, [_vm._v("23. Nile Echoes")])]), _vm._v(" "), _c('h3', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/1cover"
    }
  }, [_vm._v("Jericho Mosaic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/8chap1#chap1"
    }
  }, [_vm._v("Introduction by James Hougan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v4/9chap2#chap2"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v4/10chap3#chap3"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/11chap4#chap4"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/12chap5#chap5"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/13chap6#chap6"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/14chap7#chap7"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/15chap8#chap8"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/16chap9#chap9"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/17chap10#chap10"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/18chap11#chap11"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/19chap12#chap12"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/20chap13#chap13"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/21chap14#chap14"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/22chap15#chap15"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/23chap16#chap16"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/24chap17#chap17"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v4/25chap18#chap18"
    }
  }, [_vm._v("Part Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v4/26chap19#chap19"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/27chap20#chap20"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/28chap21#chap21"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/29chap22#chap22"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/30chap23#chap23"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/31chap24#chap24"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/32chap25#chap25"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/33chap26#chap26"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/34chap27#chap27"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/35chap28#chap28"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v4/36chap29#chap29"
    }
  }, [_vm._v("Part Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v4/37chap30#chap30"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/38chap31#chap31"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/39chap32#chap32"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/40chap33#chap33"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/41chap34#chap34"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/42chap35#chap35"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/43chap36#chap36"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/44chap37#chap37"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/45chap38#chap38"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/46chap39#chap39"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/47chap40#chap40"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/48chap41#chap41"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/49chap42#chap42"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/50chap43#chap43"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/51chap44#chap44"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/v4/52chap45#chap45"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v4/53chap46#chap46"
    }
  }, [_vm._v("An Editorial Relationship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v4/54biography"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be0d42ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/3-TOC.vue
// module id = 72
// module chunks = 0